// extracted by mini-css-extract-plugin
export default {"invite_field":"InviteField_invite_field__ynoIe","inviter_field":"InviteField_inviter_field__3vtNm","invite_decision_btn":"InviteField_invite_decision_btn__xGBUs"};